import { useEffect } from 'react';
import brandManager from '../Services/brandManager';
import useLandingStore from '../Store/Landing';

export const useBrandManager = () => {
  const landingData = useLandingStore((state) => state.landingData);

  useEffect(() => {
    if (landingData?.brandName && landingData?.logoUrl) {
      brandManager.initializeBrand(landingData);
    }
  }, [landingData]);

  return {
    currentBrand: brandManager.getCurrentBrand(),
    updateBrand: brandManager.registerBrandPWA.bind(brandManager),
    updateFavicon: brandManager.updateFavicon.bind(brandManager),
    updatePageTitle: brandManager.updatePageTitle.bind(brandManager)
  };
};
